<div class="position-fixed top-0 end-0 p-3" style="z-index: 1050;">
  @if (download.loading()) {
    <div class="card">
      <div class="card-body p-0">
        <div class="d-flex align-items-center bg-light border rounded shadow-sm p-2">
          <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
          <small>{{ download.bytes() | bytes }} downloaded</small>
        </div>
      </div>
    </div>
  }
</div>
